import { useEffect, useState } from 'react'

import { QuestionType } from '@factorialco/f0-react/dist/experimental'

import { FormEditor } from 'modules/forms/components/newFormEditor/formEditor'

import { QuestionnaireType } from './types'

export const FormWithoutAgent = ({
  initialState,
  setForm,
  savedState,
  reloadKey,
  allowedQuestionTypes,
}: {
  initialState: QuestionnaireType
  setForm: (form: QuestionnaireType) => void
  savedState: QuestionnaireType
  reloadKey: number
  allowedQuestionTypes?: QuestionType[]
}) => {
  const [state, setState] = useState<QuestionnaireType>(initialState)

  const handleChange = (questionnaire: QuestionnaireType) => {
    setState(questionnaire)
  }

  useEffect(() => {
    setForm(state)
  }, [state, setForm])

  useEffect(() => {
    if (reloadKey > 0) {
      setState(savedState)
    }
  }, [reloadKey])

  return (
    <FormEditor state={state} setState={handleChange} allowedQuestionTypes={allowedQuestionTypes} />
  )
}
